<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th>{{ $t("other.流水创建日期") }}</th>
            <th>{{ $t("other.流水备注内容") }}</th>
            <th>{{ $t("other.支出金额") }}</th>
            <th>{{ $t("other.状态") }}</th>
            <th class="tx-center">{{ $t("other.操作日志") }}</th>
            <th>{{ $t("other.操作") }}</th>
          </tr>
        </thead>
        <tbody class="tx-12">
          <tr v-for="item in items" :key="item.id">
            <td class="valign-middle">
              <div class="tx-white">{{ item.timeCreated | dateFormat }}</div>
            </td>
            <td class="valign-middle">
              <div class="tx-white">
                {{ item.remark ? item.remark : $t("other.无") }}
              </div>
            </td>
            <td class="valign-middle">
              <div class="tx-white">￥ {{ item.amount }}</div>
            </td>
            <td class="valign-middle">
              <div :class="item.status == 1 ? 'tx-success' : 'tx-danger'">
                {{ $t($dict.costFlowStatus[item.status]) }}
              </div>
            </td>
            <td class="valign-middle tx-center">
              <div>
                <a
                  href="javascript:;"
                  :class="
                    item.operateLog && item.operateLog.length
                      ? 'tx-info'
                      : 'tx-gray'
                  "
                  @click="showOperateLog(item.operateLog)"
                >
                  <i class="icon ion-chatbox-working tx-20"></i>
                </a>
              </div>
            </td>
            <td class="valign-middle">
              <template v-if="item.status != '2'">
                <div
                  class="mg-b-5"
                  v-if="isSysRights('Profit.changeOtherCostFlow')"
                >
                  <a
                    class="tx-info"
                    href="javascript:;"
                    @click="modiCostFlow(item)"
                    >{{ $t("other.修改") }}</a
                  >
                </div>
                <div v-if="isSysRights('Profit.cancelOtherCostFlow')">
                  <a
                    class="tx-danger"
                    href="javascript:;"
                    @click="cancelCostFlow(item)"
                    >{{ $t("other.作废") }}</a
                  >
                </div>
              </template>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="6">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{ $t("other.没有符合条件的流水") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  filters: {
    dateFormat(date) {
      return moment(date, "YYYY-MM-DD hh:mm:ss").format("YYYY-MM-DD hh:mm");
    },
  },
  methods: {
    showOperateLog(item) {
      this.$emit("showOperateLog", item);
    },
    cancelCostFlow(item) {
      this.$emit("cancelCostFlow", item);
    },
    modiCostFlow(item) {
      this.$emit("modiCostFlow", item);
    },
  },
};
</script>